<script>
import Page from '~/components/CMS/Page';

export default {
  ...Page,

  nuxtI18n: {
    locales: [ 'fr' ],
  },

  async asyncData({ route, app }) {
    const slug    = route.params.slug;
    const content = await app.$content('fr/blog', slug).fetch();
    const data    = { showSocialSharing: true, content: content };

    return data;
  },
};
</script>
